import { Button } from "@/components/Button";
import { cn } from "@/lib/utils";
import { Gift, Sparkles } from "lucide-react";
import React from "react";
import { UserAvatar } from "@/components/UserAvatar";

export function FeedHeader({ openGiveModal, user }) {
  // Safe defaults if user is not fully loaded
  const avatarUrl = user?.avatar_url || `https://ui-avatars.com/api/?name=${user?.full_name || 'User'}&background=6da100&color=fff`;
  const points = user?.points_balance || 0;
  const allowance = user?.monthly_allowance || 0;
  const boost = user?.allowance_boost || 0;
  const spent = user?.monthly_spent || 0;
  const totalAvailable = allowance + boost - spent;

  return (
    <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-4 mb-6">
      <div className="flex items-center gap-3">
        {/* 1. Sender Avatar */}
        {/* 1. Sender Avatar */}
        <UserAvatar user={user} size={48} className="border-2 border-white shadow-sm flex-shrink-0" />

        {/* 2. Input Trigger with Embedded Badge */}
        <div
          onClick={openGiveModal}
          className="flex-1 bg-gray-50 hover:bg-white hover:ring-2 hover:ring-bambu-green/20 hover:shadow-md transition-all duration-300 rounded-2xl border border-gray-200 cursor-pointer flex items-center justify-between px-4 py-2.5 group relative"
        >
          <span className="text-gray-500 font-medium group-hover:text-gray-700 font-montserrat truncate text-sm sm:text-base">
            ¿A quién quieres reconocer hoy?
          </span>

          <div className="hidden sm:flex items-center bg-white text-bambu-green px-3 py-1 rounded-full text-xs font-black border border-bambu-green/20 shadow-sm gap-1 ml-2">
            <span className="text-gray-400 font-normal">Tienes</span>
            <span>{totalAvailable} pts</span>
            {boost > 0 && (
              <span className="text-[10px] font-normal text-orange-500 ml-1">
                (+{boost} boost)
              </span>
            )}
          </div>
        </div>

        {/* 3. Give Button (Pill with Text) */}
        <Button
          onClick={openGiveModal}
          className="rounded-full px-5 h-11 flex items-center gap-2 bg-bambu-green hover:bg-bambu-dark-green shadow-sm hover:shadow-md transition-all flex-shrink-0"
        >
          <Gift className="w-4 h-4 text-white" />
          <span className="font-bold text-sm text-white">Dar</span>
        </Button>
      </div>
    </div>
  );
}
